<template>
  <v-app id="app">
    <div id="map"></div>

    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      absolute
      width="370"
      class="grey lighten-4"
    >
      <div class="naviga">
        <!-- <div class="v-card__title pa-0 mt-2 mb-3 ml-1">
          <div class="title">Find</div>
        </div> -->
        <v-card class="mb-2" v-if="!mini">
          <v-card-title class="pb-0">
            <div class="title">Draw Sheltebelt</div>
            <v-spacer />
            <v-btn dark color="green darken-2" round outline @click="clearDraw"
              >Clear Drawing</v-btn
            >
          </v-card-title>
          <v-card-text>
            <p class="my-2">
              Click to start | Click to draw | Double click to stop
            </p>
            <v-divider class="my-3" />
            <div class="subheading">
              Total length: <strong>{{ formatArea(totalLength) }}</strong>
            </div>
            <v-divider class="my-3" />
            <v-btn round color="green darken-2" dark to="/removal"
              >Inventory and Removal</v-btn
            >
            <v-btn
              round
              color="green darken-2"
              dark
              @click.native="goto('calculate')"
              >Go to Calculate</v-btn
            >
            <v-btn
              round
              color="green darken-2"
              dark
              @click.native="goto('carbon_past')"
              >Go to Past Carbon</v-btn
            >
            <v-btn
              round
              color="green darken-2"
              dark
              @click.native="goto('carbon_future')"
              >Go to Future Carbon</v-btn
            >
          </v-card-text>
        </v-card>
        <v-card class="mb-2" v-if="!mini">
          <v-card-text class="pa-1">
            <v-list class="my-3">
              <template v-for="(layer, index) in layerList">
                <v-list-tile
                  v-if="layer.values_.id != 3"
                  :key="index"
                  @click="changeLayers(layer)"
                >
                  <v-list-tile-action>
                    <v-switch
                      v-model="layer.values_.visible"
                      hide-details
                      small
                      color="green lighten-2"
                      @click="changeLayers(layer)"
                    ></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      layer.values_.name
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider
                  :key="layer.values_.name"
                  v-if="layerList.length - 2 > index"
                ></v-divider>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
        <v-card class="mb-2" v-if="!mini">
          <v-card-text>
            <v-tabs color="transparent">
              <v-tab href="#tab-1">LLD</v-tab>
              <v-tab href="#tab-2">Lat/Long</v-tab>
              <v-tabs-slider color="green"></v-tabs-slider>
              <v-tab-item value="tab-1">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-combobox
                          v-model="lld.section"
                          :items="sections"
                          label="Sections"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs6>
                        <v-combobox
                          v-model="lld.township"
                          :items="townships"
                          label="Townships"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs6>
                        <v-combobox
                          v-model="lld.range"
                          :items="ranges"
                          label="Ranges"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs6>
                        <v-combobox
                          v-model="lld.meridian"
                          :items="meridians"
                          label="Meridian"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs3>
                        <v-btn
                          dark
                          color="green darken-2"
                          round
                          class="ma-0"
                          @click="submitLLD()"
                          >Go</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-tab-item>
              <v-tab-item value="tab-2">
                <v-form ref="formLatLong" v-model="valid" lazy-validation>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field
                          v-model="latitude"
                          label="Latitude"
                          hide-details
                          flat
                          :rules="lldRules"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          v-model="longitude"
                          label="Longitude"
                          hide-details
                          flat
                          :rules="lldRules"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs3>
                        <v-btn
                          dark
                          color="green darken-2"
                          round
                          class="ma-0"
                          @click="submitLatLong()"
                          >Go</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </v-card>
      </div>
    </v-navigation-drawer>

    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      fixed
      color="green darken-2"
      dark
      height="58"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="mr-5">ShelterBelt</v-toolbar-title>

      <v-layout wrap flex class="mx-5 text-xs-center grow">
        <v-flex xs12 sm8 id="search">
          <!-- <v-form ref="formSearch" v-model="valid" lazy-validation> -->
          <v-text-field
            v-model="address"
            label="Enter city or address"
            hide-details
            flat
            solo-inverted
            :rules="lldRules"
            required
            @keyup.enter.native="submitSearch()"
          >
            <template v-slot:append-outer class="ma-0">
              <v-btn
                id="search-btn"
                @click.prevent="submitSearch()"
                flat
                dark
                class="search-btn"
              >
                <v-icon dark>search</v-icon>
              </v-btn>
            </template>
          </v-text-field>
          <!-- </v-form> -->
        </v-flex>
      </v-layout>
    </v-toolbar>

    <div class="baselayer">
      <div v-on:click="changeMap()" v-if="!mapSelect">
        <img :src="`${publicPath}/static/google.jpg`" />
        <div class="map-name">Google</div>
      </div>
      <div v-on:click="changeMap()" v-else>
        <img :src="`${publicPath}/static/openstreet.jpg`" />
        <div class="map-name">Open Street</div>
      </div>
    </div>

    <v-snackbar v-model="snackbar" :timeout="6000">
      {{ snackbarMessage }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="green darken-2" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
var geoconfig = require("./../geo_config");
import { layers, basemaps } from "./../geo_config";
import axios from "axios";
import draw from "../mixins/draw";
import generic from "../mixins/generic";

import OLGoogleMaps from "olgm/OLGoogleMaps.js";
import { defaults as defaultInteractions } from "olgm/interaction.js";
import Feature from "ol/Feature.js";
import Map from "ol/Map.js";
import {
  Group as LayerGroup,
  Tile as TileLayer,
  Vector as VectorLayer
} from "ol/layer.js";
import { OSM, Vector as VectorSource } from "ol/source.js";
import { Fill, Style } from "ol/style.js";
import View from "ol/View.js";
import {
  defaults as defaultControls,
  ScaleLine,
  FullScreen,
  OverviewMap,
  ZoomSlider
} from "ol/control.js";
import { get as getProjection, transform } from "ol/proj.js";
import { Draw, Modify, Snap } from "ol/interaction.js";
import { LineString } from "ol/geom.js";
import MousePosition from "ol/control/MousePosition.js";
import Overlay from "ol/Overlay.js";
import { unByKey } from "ol/Observable.js";
import { getLength } from "ol/sphere.js";

export default {
  mixins: [draw, generic],
  data() {
    return {
      dialog: false,
      publicPath: process.env.BASE_URL,
      snackbar: false,
      snackbarMessage: "",
      drawer: null,
      mini: false,
      lld: {
        range: null,
        meridian: null,
        township: null,
        section: null
      },
      latitude: null,
      longitude: null,
      address: null,
      geoloc: null,
      map: {},
      clickLocationFeature: {},
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      sections: [],
      townships: [],
      ranges: [],
      meridians: [],
      mapSelect: "Google",
      draw: null,
      source: null,
      typeSelect: "LineString",
      tempLength: 0,
      valid: true,
      lldRules: [v => !!v || "Required"],
      center: [-11900148, 6900099],
      view: null,
      topo: null,
      measureTooltipElement: null,
      measureTooltip: null,
      helpTooltipElement: null,
      continueLineMsg: "Click to continue drawing the line",
      sketch: null,
      listener: null,
      snap: null,
      layerList: geoconfig.layers,
      lineLenght: 0
    };
  },
  computed: {
    ...mapGetters({
      totalLength: "getTotalLenght"
    }),
    arrayList: {
      get: function() {
        return this.$store.state.points;
      },
      set: function(val) {
        this.$store.dispatch("setPoints", val);
      }
    },
    zoom: {
      get: function() {
        return this.$store.state.zoom;
      },
      set: function(val) {
        this.$store.dispatch("setZoom", val);
      }
    }
  },
  mounted() {
    this.initMap();
    this.initDropDownValues();

    this.layerList.forEach(function(item) {
      if (item.values_.name == "Draw" && item.values_.visible) {
        item.values_.visible = false;
        this.changeLayers(item);
      }
    }, this);
  },
  methods: {
    changeMap() {
      this.mapSelect = !geoconfig.googleMap.getVisible();
      geoconfig.googleMap.setVisible(!geoconfig.googleMap.getVisible());
      geoconfig.openStreeMap.setVisible(!geoconfig.openStreeMap.getVisible());
    },
    changeLayers(item) {
      var data = item.values_.visible == true ? false : true;
      item.setVisible(data);
      item.setZIndex(item.values_.id);

      if (item.values_.name == "Draw" && data) {
        this.typeSelect = "LineString";
        geoconfig.nodesLayer.setVisible(true);
        geoconfig.nodesLayer.setZIndex(3);
        this.initDraw();
      } else {
        this.typeSelect = "None";
        geoconfig.nodesLayer.setVisible(false);
        this.helpTooltipElement = null;
        this.helpTooltip = null;
        this.map.removeInteraction(this.draw);
        this.map.removeInteraction(this.snap);
        this.map.removeOverlay(this.helpTooltipElement);
        this.map.removeOverlay(this.helpTooltip);
      }
    },
    createMeasureTooltip() {
      if (this.measureTooltipElement) {
        this.measureTooltipElement.parentNode.removeChild(
          this.measureTooltipElement
        );
      }
      this.measureTooltipElement = document.createElement("div");
      this.measureTooltipElement.className = "tooltip tooltip-measure";
      this.measureTooltip = new Overlay({
        element: this.measureTooltipElement,
        offset: [0, -15],
        positioning: "bottom-center"
      });
      this.map.addOverlay(this.measureTooltip);
    },
    createHelpTooltip() {
      if (this.helpTooltipElement) {
        this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
      }
      this.helpTooltipElement = document.createElement("div");
      this.helpTooltipElement.className = "tooltip hidden";
      this.helpTooltip = new Overlay({
        element: this.helpTooltipElement,
        offset: [15, 0],
        positioning: "center-left"
      });
      this.map.addOverlay(this.helpTooltip);
    },
    clearDraw() {
      geoconfig.drawSource.clear();
      geoconfig.nodeSource.clear();

      this.$store.dispatch("setLength", 0);
      this.$store.dispatch("setPoints", []);

      this.initDraw();
    },
    initDraw() {
      this.map.removeInteraction(this.draw);
      this.map.removeInteraction(this.snap);
      this.addInteraction();

      this.map.on("pointermove", this.pointerMoveHandler);

      this.map.getViewport().addEventListener("mouseout", function() {
        if (this.helpTooltipElement != undefined) {
          this.helpTooltipElement.classList.add("hidden");
        }
      });

      this.createMeasureTooltip();
      this.createHelpTooltip();
    },
    addInteraction() {
      if (this.typeSelect === "LineString") {
        this.draw = new Draw({
          type: this.typeSelect
        });

        this.map.addInteraction(this.draw);

        this.snap = new Snap({
          source: geoconfig.drawSource
        });
        this.map.addInteraction(this.snap);
        // this.map.addControl(new MousePosition());
        this.draw.on("drawend", this.onDrawend);
        this.createMeasure();
      }
    },
    pointerMoveHandler(evt) {
      if (this.typeSelect === "LineString") {
        if (evt.dragging) {
          return;
        }
        /** @type {string} */
        var helpMsg = "Click to start drawing";

        if (this.sketch) {
          var geom = this.sketch.getGeometry();
          if (geom instanceof LineString) {
            helpMsg = this.continueLineMsg;
          }
        }

        this.helpTooltipElement.innerHTML = helpMsg;
        this.helpTooltip.setPosition(evt.coordinate);

        this.helpTooltipElement.classList.remove("hidden");
      }
    },
    createMeasure() {
      let vm = this;
      // console.log('vm.tempLength', vm.tempLength);
      var length = 0;

      vm.draw.on("drawstart", function(evt) {
        vm.sketch = evt.feature;
        var tooltipCoord = evt.coordinate;

        this.listener = vm.sketch.getGeometry().on("change", function(evt) {
          var geom = evt.target;
          var length = getLength(geom);
          var total = vm.totalLength + length;

          vm.measureTooltipElement.innerHTML = vm.formatLength(total);
          vm.tempLength = total;

          if (total < 10000) {
            vm.lineLenght = total;
            tooltipCoord = geom.getLastCoordinate();
            vm.measureTooltip.setPosition(tooltipCoord);
          } else {
            vm.snackbarMessage =
              "Must be a draw length with a maximum length of 10km.";
            vm.snackbar = true;
          }
        });
      });

      vm.draw.on("drawend", function(evt) {
        vm.measureTooltipElement.className = "tooltip tooltip-static";
        vm.measureTooltip.setOffset([0, -7]);
        // unset sketch
        vm.sketch = null;
        // unset tooltip so that a new one can be created
        vm.measureTooltipElement = null;
        vm.createMeasureTooltip();

        unByKey(vm.listener);
      });
    },
    initMap() {
      this.view = new View({
        center: this.center,
        zoom: this.zoom
      });

      this.map = new Map({
        interactions: defaultInteractions(),
        controls: defaultControls().extend([new FullScreen()]),
        layers: [
          geoconfig.googleMap,
          geoconfig.openStreeMap,
          new LayerGroup({ layers: geoconfig.layers })
        ],
        target: "map",
        view: this.view
      });

      const olGM = new OLGoogleMaps({ map: this.map }); // map is the Map instance
      olGM.activate();

      this.map.on("singleclick", e => {
        this.handleMapClick(e);
      });

      this.topo = topolis.createTopology();

      this.topo.on("addnode", this.nodeToFeature);
      this.topo.on("removenode", function(e) {
        this.removeElementFeature(geoconfig.nodeSource, e);
      });

      this.topo.on("addedge", this.edgeToFeature);
      this.topo.on("modedge", function(e) {
        var feature = geoconfig.drawSource.getFeatureById(e.id);
        feature.setGeometry(new LineString(e.coordinates));
      });

      this.topo.on("removeedge", function(e) {
        this.removeElementFeature(geoconfig.drawSource, e);
      });
    },
    initDropDownValues() {
      var i = 0;
      for (i = 1; i <= 36; i++) {
        this.sections.push(i);
      }
      for (i = 1; i <= 64; i++) {
        this.townships.push(i);
      }
      this.townships.push("19A");
      this.townships.push("27A");
      this.townships.push("42A");
      this.townships.push("43A");
      this.townships.push("45A");
      this.townships.push("46A");
      this.townships.push("47A");
      for (i = 1; i <= 34; i++) {
        this.ranges.push(i);
      }
      this.ranges.push("13A");
      this.ranges.push("21A");
      this.ranges.push("24A");

      for (i = 1; i <= 4; i++) {
        this.meridians.push(i);
      }
    },
    handleMapClick(event) {
      var view = this.map.getView();
      var viewResolution = view.getResolution();
      var source = geoconfig.layers[0].getSource();

      this.latitude = event.coordinate[0];
      this.longitude = event.coordinate[1];
    },
    submitLatLong() {
      let vm = this;

      if (vm.$refs.formLatLong.validate()) {
        vm.dialog = true;

        axios
          .get(
            `${process.env.OPENDATA}/json?q=${vm.latitude},${vm.longitude}&key=c4ac603702ae419597108bb597a280fd&language=en&pretty=1`
          )
          .then(response => {
            var points = response.data.results;
            if (points.length > 0) {
              let geometry = points[0].annotations.Mercator;
              if (geometry != undefined) {
                vm.viewCenter(parseFloat(geometry.x), parseFloat(geometry.y));
              }
            } else {
              vm.snackbarMessage =
                "Please try again. It did not match with any city.";
              vm.snackbar = true;
            }
            vm.dialog = false;
          })
          .catch(err => {
            console.log(err);
            vm.dialog = false;
          });
      }
    },
    submitSearch() {
      let vm = this;
      if (vm.address != null) {
        vm.dialog = true;
        axios
          .get(
            `${process.env.OPENDATA}/json?q=${vm.address}&key=c4ac603702ae419597108bb597a280fd&language=en&pretty=1`
          )
          .then(response => {
            var points = response.data.results;
            if (points.length > 0) {
              let geometry = points[0].annotations.Mercator;
              if (geometry != undefined) {
                vm.viewCenter(parseFloat(geometry.x), parseFloat(geometry.y));
              }
            } else {
              vm.snackbarMessage = "Please try again. It did not match.";
              vm.snackbar = true;
            }
            vm.dialog = false;
          })
          .catch(err => {
            vm.dialog = false;
            console.log(err);
          });
      }
    },
    submitLLD() {
      let vm = this;
      let body = [];
      vm.dialog = true;

      var instanceApi = axios.create({
        baseURL: process.env.SKSOILS
      });
      instanceApi.interceptors.request.use(
        config => {
          config.headers.common["X-DreamFactory-Api-Key"] = process.env.SKSOILS_KEY;
          return config;
        },
        error => {
          return Promise.reject(error);
        }
      );

      if (vm.lld.section != null)
        body.push({ name: "v_sect", value: vm.lld.section });
      if (vm.lld.township != null)
        body.push({ name: "v_ptwp", value: vm.lld.township });
      if (vm.lld.range != null)
        body.push({ name: "v_prge", value: vm.lld.range });
      if (vm.lld.meridian != null)
        body.push({ name: "v_pmer", value: vm.lld.meridian });

      if (body.length > 0) {
        let prms = {
          params: body
        };
        instanceApi
          .get("/sksoil/_proc/get_center_section", prms)
          .then(response => {
            let coordinate = response.data;

            if (
              coordinate.center_point != null &&
              coordinate.x != null &&
              coordinate.y != null
            ) {
              vm.viewCenter(coordinate.x, coordinate.y);
            } else {
              vm.snackbarMessage = "Please try again. It did not match.";
              vm.snackbar = true;
            }
            vm.dialog = false;
          })
          .catch(err => {
            vm.dialog = true;
            console.log(err);
          });
      }
    },
    viewCenter(x, y) {
      this.zoom = this.map.getView().getZoom();

      if (this.zoom < 12) {
        this.zoom = 12;
      }
      this.view.animate({ zoom: this.zoom }, { center: [x, y] });
    },
    goto(type) {
      if (this.arrayList.length > 0 && this.totalLength > 0) {
        let coordi = transform(this.arrayList[0], "EPSG:3857", "EPSG:4326");
        let url = "";

        this.$store.dispatch("setZoom", this.map.getView().getZoom());
        if (type == "calculate") {
          url = `/row/${this.changeRound(this.totalLength)}/${this.changeRound(coordi[0])}/${this.changeRound(coordi[1])}`;
          // this.$router.push(`/row/${this.changeRound(this.totalLength)}/${this.changeRound(coordi[0])}/${this.changeRound(coordi[1])}`)
        }
        if (type == "carbon_past") {
          url = `/carbon_past/${this.changeRound(this.totalLength)}/${this.changeRound(coordi[0])}/${this.changeRound(coordi[1])}`;
          // this.$router.push(`/carbon_past/${this.changeRound(this.totalLength)}/${this.changeRound(coordi[0])}/${this.changeRound(coordi[1])}`)
        }
        if (type == "carbon_future") {
          url = `/carbon_future/${this.changeRound(this.totalLength)}/${this.changeRound(coordi[0])}/${this.changeRound(coordi[1])}`;
          // this.$router.push(`/carbon_future/${this.changeRound(this.totalLength)}/${this.changeRound(coordi[0])}/${this.changeRound(coordi[1])}`)
        }

        window.open(
          window.location.protocol + "//" + window.location.host + url,
          "_blank",
          "toolbar=no,titlebar=no,menubar=no,location=no,scrollbars=yes,resizable=yes,top=100,left=100,width=1300,height=650"
        );
      }
    },
    changeRound(item) {
      return Math.round(item * 10000) / 10000;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/map.vue